__turbopack_context__.v({
  "chatSpecialist": "LM1bmq_chatSpecialist",
  "ctaStack": "LM1bmq_ctaStack",
  "midPanel": "LM1bmq_midPanel",
  "midPanelPhone": "LM1bmq_midPanelPhone",
  "midPanelPhonePrice": "LM1bmq_midPanelPhonePrice",
  "midPanelPhoneRight": "LM1bmq_midPanelPhoneRight",
  "midPanelPhoneRow": "LM1bmq_midPanelPhoneRow",
  "offerIcon": "LM1bmq_offerIcon",
  "offerIcons": "LM1bmq_offerIcons",
  "root": "LM1bmq_root",
  "subtitleTextBtn": "LM1bmq_subtitleTextBtn",
  "taxDisclaimer": "LM1bmq_taxDisclaimer",
  "totalPriceSingle": "LM1bmq_totalPriceSingle",
  "tradeInCredit": "LM1bmq_tradeInCredit",
});
